var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearthsLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 11,
    fill: "#12101A",
    stroke: "#A046D3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 21.4309C22.3092 18.4892 18.0001 19.6403 18.0001 22.5308C18.0001 25.7794 22.4728 26.9305 23.9728 29.9489L24.0001 30.0001L24.0273 29.9489C25.5273 26.9305 30 25.7794 30 22.5308C30.0273 19.6403 25.6909 18.4892 24.0001 21.4309Z",
    fill: "#A046D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearthsLoader);
export default __webpack_public_path__ + "static/media/hearthsLoader.083c57e2bd5afe040d59e4ecb0cc0270.svg";
export { ForwardRef as ReactComponent };